import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AlmeMinimize from './AlmeMinimize/AlmeMinimize';
import AlmeClose from './AlmeClose/AlmeClose';
import { SwitchChatPositionButton } from './SwitchChatPosition/SwitchChatPositionButton';
import SelectAccount from './SelectAccount';
const HeaderContainer = styled.div `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap !important;
    justify-content: space-between;
    align-items: baseline;
    padding: .75rem 1rem;
    margin: 0;
    border-bottom: 1px solid #cccccc;
`;
const Heading = styled.h1 `
    font-size: ${props => props.theme.fontSizes.headerText};
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: black;
    background-color: white;
    margin: 0;
    padding: 0;
`;
const HeaderIconContainer = styled.div `
    display: inline-flex;
`;
const canShowSwitchPositionButton = (mobileBreakPoint) => window.innerWidth > mobileBreakPoint;
const AlmeHeader = (props) => {
    const [showSwitchPositionButton, setShowSwitchPositionButton] = useState(canShowSwitchPositionButton(props.almeAppConfig.mobileBreakpoint));
    const headerText = props.isLiveChatConnected ? props.almeAppConfig.header.liveChatHeaderText : props.almeAppConfig.header.headerText;
    useEffect(() => {
        const onResize = () => {
            const showSwitchButton = canShowSwitchPositionButton(props.almeAppConfig.mobileBreakpoint);
            if (showSwitchButton !== showSwitchPositionButton) {
                setShowSwitchPositionButton(showSwitchButton);
            }
        };
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
        };
    }, [showSwitchPositionButton, props.almeAppConfig.mobileBreakpoint]);
    return (React.createElement(HeaderContainer, null,
        React.createElement(Heading, null, headerText),
        React.createElement(HeaderIconContainer, null,
            showSwitchPositionButton && React.createElement(SwitchChatPositionButton, { focusProps: props.focusProps }),
            props.isSessionExpired
                ? null
                : React.createElement(AlmeMinimize, { almeAppConfig: props.almeAppConfig, onMinimizeClick: props.onMinimizeClick, focusProps: props.focusProps }),
            props.isLiveChatConnected
                ? null
                : React.createElement(AlmeClose, { almeAppConfig: props.almeAppConfig, onCloseClick: props.onCloseClick, setIsDialogOpen: props.setIsDialogOpen, focusProps: props.focusProps, isLoggedIn: props.isLoggedIn, chatId: props.chatId, isLivechatSurveyLoaded: props.isLivechatSurveyLoaded, isSessionExpired: props.isSessionExpired })),
        React.createElement(SelectAccount, { almeAppConfig: props.almeAppConfig, almeApiUtils: props.almeApiUtils, focusProps: props.focusProps, isLiveChatConnected: props.isLiveChatConnected, currentEnterpriseId: props.currentEnterpriseId, isAccountSwitched: props.isAccountSwitched })));
};
export default AlmeHeader;
